import { ActionsGridLayout, ActionsViewState } from '../types'
import { ActiveActionsView } from './ActiveActionsView'
import { ChainMismatchView } from './ChainMismatchView'
import { ConnectFromWatchWalletView } from './ConnectFromWatchWalletView'
import { NoActionsView } from './NoActionsView'
import { NotConnectedView } from './NotConnectedView'
import { ToSNotAcceptedView } from './ToSNotAcceptedView'

export interface ActionsViewProps {
  state: ActionsViewState
  actionsGridLayout: ActionsGridLayout
  allowChangeWhenActionsInProgress: boolean
}

export function ActionsView({ state, actionsGridLayout, allowChangeWhenActionsInProgress }: ActionsViewProps) {
  switch (state.type) {
    case 'watch-wallet':
      return <ConnectFromWatchWalletView />
    case 'not-connected':
      return <NotConnectedView />
    case 'tos-not-accepted':
      return <ToSNotAcceptedView onAccept={state.onAccept} />
    case 'chain-mismatch':
      return (
        <ChainMismatchView
          expectedChainId={state.expectedChainId}
          currentChainId={state.currentChainId}
          networkChange={state.networkChange}
        />
      )
    case 'no-actions':
      return <NoActionsView />
    case 'active':
      return (
        <ActiveActionsView
          actionHandlers={state.actionHandlers}
          batchActionHandler={state.batchActionHandler}
          actionsGridLayout={actionsGridLayout}
          settingsDialogProps={state.settingsDialogProps}
          allowChangeWhenActionsInProgress={allowChangeWhenActionsInProgress}
          canWalletBatch={state.canWalletBatch}
        />
      )
  }
}
